import { createErrorApiResponse } from "@entrilia/shared/api/axiosHelper";
import type { ApiResponse } from "@entrilia/shared/api/types";
import type { FileDownloadInfo } from "@entrilia/shared/api/fileTypes";
import adminApi from "../../../../api/adminApi";
import type { DocumentViews } from "../../../../api/types/documentActivityTypes";

export const getDocumentViewFileDownloadInfo = async (
  documentView: DocumentViews
): Promise<ApiResponse<FileDownloadInfo>> => {
  const {
    postMessageRequestId,
    fundraisingId,
    documentInfo: { attachmentId, fundraisingDocumentId },
  } = documentView;

  if (postMessageRequestId && attachmentId) {
    return adminApi.getDocCollectionFileDownloadInfo(postMessageRequestId, attachmentId);
  }

  if (fundraisingId && fundraisingDocumentId) {
    return adminApi.getFundraisingFileDownloadInfo(fundraisingId, fundraisingDocumentId);
  }

  return Promise.resolve(
    createErrorApiResponse({
      message: "Invalid document view: not enough data for file download",
      type: "General",
    })
  );
};
